const $ = jQuery;

export class WPFORO {
    
    constructor(){
        this.replies_ajax();
    }

    replies_ajax() {

        jQuery( document ).on( 'click', '.wpf-post-replies-bar.__ajax-load', function(e) {
            const $bar   = jQuery(this);
            const $post  = $bar.closest( '[data-postid]' );   // ajusta el selector si difiere
            const postId  = $post.data('postid');
            const topicId = $post.data('topicid');
            const forumId = $post.data('forumid');

            // Evitar doble carga
            if ( $bar.hasClass('wpf-lazy-loaded') || $bar.hasClass('wpf-lazy-loading') ) return;

            $bar.addClass('wpf-lazy-loading');
            $bar.parent().next().find('.__load-more').show();

            jQuery.post( appVars.ajaxUrl, {
                action:   'wpf_lazy_replies',
                nonce:    appVars.wpf_lazy_nonce,
                post_id:  postId,
                topic_id: topicId,
                forum_id: forumId,
            })
            .done( function( res ) {
                console.log(res);
                if ( res.success && res.data ) {
                    $bar.parent().next().html(res.data); // inserta el HTML de replies debajo del bar
                    $bar.addClass('wpf-lazy-loaded');
                    $bar.parent().next().find('.wpf-post-replies').show();
                }
            })
            .always( function() {
                $bar.removeClass('wpf-lazy-loading');
            });
        } );
    }
}